export default "__VITE_ASSET__C3PS15MZ__"